// extracted by mini-css-extract-plugin
export default {"property__container":"properties_property__container__Qjb3l","property__div":"properties_property__div__d0S8R"};